import { createFileRoute } from '@tanstack/react-router';
import { Edital } from '@pages/Edital/[id]';

// A autenticação vive no proxy do front (server/), não no cliente: tokens NÃO
// trafegam por query param nem pelo navegador. Por isso este arquivo não
// persiste mais `?token=` — fazê-lo reintroduziria a exposição da credencial.
export const Route = createFileRoute('/edital/$id')({
  component: Edital,
});
